module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ChTitle",
    attrs: {
      "id": "ch18"
    }
  }, [_c('a', {
    attrs: {
      "id": "ch18aa"
    }
  }), _c('a', {
    attrs: {
      "id": "ch18a"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rch18"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("THE DEATH OF GERALD BULL")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_c('i', [_vm._v("Who killed the Canadian “Boy Rocket Scientist” who grew up to design a gun for Saddam Hussein?")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("B")]), _c('b', [_vm._v("ACKGROUND")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Gerald Bull (1928-1990) was born in North Bay, Ontario. He graduated from the University of Toronto at the age of 20, got a master’s degree at age 21, and a Ph.D. in aeronautical engineering (and a job heading the aerospace division at the Canadian Armament Research Development Establishment) at age 22. While at McGill University in 1962 he designed an artillery shell that hit a predetermined altitude and then fired a second rocket. Magazines called him “Boy Rocket Scientist.” His dream was to use artillery to launch satellites into space.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Bull tried to sell his ideas to Western governments, but the United States wasn’t interested. (NASA wanted to focus on rockets, not weapons.) So, feeling abandoned and insulted, Bull started the Space Research Corporation in 1967 and sold his gun-making expertise to anyone in the world market. This included a 1980 sale of 30,000 artillery shells to South Africa, which violated an American arms embargo and led to a six-month prison term. Not long after his release, he was asked to lead Iraq’s “Project Babylon.” Saddam Hussein is reported to have personally invited Bull to design a Supergun, a howitzer with a 32-inch diameter barrel capable of sending 1,200-pound packages 600 miles into space. This meant that Hussein would be able to bomb targets thousands of miles away from Iraq.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1s"
  }, [_c('span', [_c('b', [_vm._v("MYSTERIOUS DEATH")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("On March 22, 1990, in Uccle, a suburb of Brussels, Bull opened his apartment door to find a gunman hiding in the shadows. The killer fired five bullets into the inventor’s head. Gerald Bull was 62.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("There were many suspicious facts. For one, Bull had $20,000 in cash in his pocket when he was shot. The killer didn’t take it. For "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("another, in the weeks following his murder, British Customs impounded eight steel “petroleum pipes” bound for Iraq. The pipes matched Bull’s early designs for an enormous gun. Over the next two weeks, five other components were found across Europe. And finally—Project Babylon’s chemical-warfare expert, an American named Steven Adams, had discovered Bull’s body. Later that day, Adams vanished.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center7"
  }, [_c('span', [_c('b', [_vm._v("Let’s move there! In Italy, you can buy fresh-baked pizza from vending machines.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1s"
  }, [_c('span', [_c('b', [_vm._v("CONSPIRACY THEORIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("So who assassinated Gerald Bull? No one wanted to see Hussein with a Supergun, so every country is a suspect.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangs"
  }, [_c('span', [_vm._v("•"), _c('span', {
    staticClass: "spx"
  }, [_c('i', [_c('b', [_vm._v("Theory #1: The British did it.")])]), _vm._v(" Did Margaret Thatcher dispatch MI-5 operatives to assassinate Bull to eliminate competition with British interests in the black-market weapons trade? A week after Bull’s murder, British journalist Jonathan Moyle was found dead in Santiago, Chile, with a pillowcase over his head. He’d been researching a story on British ties to Iraqi weapons buyers.")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangs"
  }, [_c('span', [_vm._v("•"), _c('span', {
    staticClass: "spx"
  }, [_c('i', [_c('b', [_vm._v("Theory #2: The Iraqis did it.")])]), _vm._v(" Saddam Hussein wanted to keep the Supergun a secret. A week before Bull was killed in Brussels, the Iraqis executed an Iranian-born British journalist named Farzad Bazoft, who was asking questions about Bull and Adams. Sources say the Iraqis sent a jet to get Adams out of Brussels, but the Belgian defenses intercepted it. It’s also possible the Iraqis thought the two were spying for the United States.")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangs"
  }, [_c('span', [_vm._v("•"), _c('span', {
    staticClass: "spx"
  }, [_c('i', [_c('b', [_vm._v("Theory #3: The CIA did it.")])]), _vm._v(" The U.S. was no friend to Saddam Hussein, and no friend to weapons consultants who helped him. Remember, the United States put Bull in prison in 1980 for violating an arms embargo. Bull’s son Michael initially blamed the CIA, but later changed his opinion to…")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangs"
  }, [_c('span', [_vm._v("•"), _c('span', {
    staticClass: "spx"
  }, [_c('i', [_c('b', [_vm._v("Theory #4: The Israelis did it.")])]), _vm._v(" And he’s not the only one. Two years after Bull’s murder, a British engineer named Christopher Crowley testified before the House of Commons that he and Bull regularly supplied Western intelligence agents with information about the Supergun. In the 1980s, Israel was quick to respond to any threats from Iraq, so Crowley believes Israeli intelligence (the Mossad) had the gun’s inventor eliminated.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("So who murdered Gerald Bull? The case remains officially unsolved.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center7"
  }, [_c('span', [_c('b', [_vm._v("Four out of 10 workplace dating relationships result in marriage.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c20bd6be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter018.vue
// module id = 132
// module chunks = 0